var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import FSSwitch from '@components/FSSwitch';
import { useYearsActions } from '@data/hooks/timePoints';
import { Plus } from '@shared/icons/icons';
import Manager from '@shared/modal/Manager';
import { Confirmation } from '@shared/modal/Simple';
import React, { useState } from 'react';
import { FaCog } from 'react-icons/fa';
import { toTimePointsByYearMap } from '../../../data/timePoint/timePoint';
import YearsSetupModal from './YearsSetupModal';
function YearItem(props) {
    var _this = this;
    var L = useLanguage().L;
    var _a = useYearsActions(), updateYear = _a.updateYear, deleteYear = _a.deleteYear;
    var year = props.year, disabled = props.disabled, isFirstOrLast = props.isFirstOrLast, isYearActive = props.isYearActive, setOperationPending = props.setOperationPending;
    function deleteHandler() {
        var _this = this;
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L('Confirm delete operation')), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setOperationPending(true);
                            return [4 /*yield*/, deleteYear(year)];
                        case 1:
                            _a.sent();
                            setOperationPending(false);
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("span", null,
                L('Are you sure you want to delete the year '),
                " ",
                React.createElement("b", null, year),
                "?")));
    }
    var isDeleteDisabled = disabled || !isFirstOrLast;
    return (React.createElement("li", { className: "year-item" },
        React.createElement("div", { className: "years-year year-value" },
            React.createElement("h5", null, year)),
        React.createElement("div", { className: "years-options" },
            React.createElement("div", { className: "options-container" },
                React.createElement(FSSwitch, { disabled: disabled, checked: isYearActive, onChange: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setOperationPending(true);
                                    return [4 /*yield*/, updateYear({ year: year, active: e.target.checked })];
                                case 1:
                                    _a.sent();
                                    setOperationPending(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); } }),
                React.createElement(FSButton, { "$type": "tertiary", "$color": "error", title: L('Delete'), disabled: isDeleteDisabled, onClick: deleteHandler })))));
}
function Years(props) {
    var e_1, _a;
    var _b;
    var dts = props.dts;
    var L = useLanguage().L;
    var _c = __read(useState(false), 2), operationPending = _c[0], setOperationPending = _c[1];
    var createYear = useYearsActions().createYear;
    var groupedYears = toTimePointsByYearMap(dts);
    var years = Object.keys(groupedYears);
    var previousYear = years.length > 0 ? +years[0] - 1 : new Date().getFullYear();
    var nextYear = years.length > 0 ? +years[years.length - 1] + 1 : new Date().getFullYear();
    var idx = 0;
    var isYearActive;
    var isFirstOrLast;
    var activeCount = 0;
    var yearItemsData = [];
    try {
        for (var years_1 = __values(years), years_1_1 = years_1.next(); !years_1_1.done; years_1_1 = years_1.next()) {
            var year = years_1_1.value;
            isYearActive = (_b = groupedYears[Number(year)]) === null || _b === void 0 ? void 0 : _b.reduce(function (isActive, month) { return isActive || month.active; }, false);
            isFirstOrLast = idx === 0 || idx === years.length - 1;
            isYearActive && activeCount++;
            idx++;
            yearItemsData.push({
                key: year,
                year: Number(year),
                isYearActive: isYearActive,
                isFirstOrLast: isFirstOrLast,
                setOperationPending: setOperationPending,
                disabled: operationPending || years.length === 1,
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (years_1_1 && !years_1_1.done && (_a = years_1.return)) _a.call(years_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var yearItems = yearItemsData.map(function (yid) {
        if (activeCount === 1 && yid.isYearActive) {
            return React.createElement(YearItem, __assign({}, yid, { disabled: true }));
        }
        return React.createElement(YearItem, __assign({}, yid));
    });
    function onClickHandler(year) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!operationPending) return [3 /*break*/, 2];
                        setOperationPending(true);
                        return [4 /*yield*/, createYear(year, {
                                onSettled: function () {
                                    setOperationPending(false);
                                },
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement("div", { className: "years-container" },
        React.createElement("div", { className: "years-header" },
            React.createElement("h4", { className: "years-title" }, L('Years')),
            React.createElement("div", { className: "button-container" },
                React.createElement(FSButton, { disabled: operationPending, title: L('Add') + ' ' + previousYear, icon: Plus, "$type": "secondary", className: "header-button_inv", onClick: function () { return onClickHandler(previousYear); } }),
                React.createElement(FSButton, { disabled: operationPending, title: L('Add') + ' ' + nextYear, icon: Plus, "$type": "secondary", className: "header-button_inv", onClick: function () { return onClickHandler(nextYear); } }),
                React.createElement(FSButton, { "$type": "tertiary", disabled: operationPending, icon: FaCog, onClick: function () { return Manager.renderModal(React.createElement(YearsSetupModal, null)); } }))),
        React.createElement("div", { className: "years-content" },
            React.createElement("div", { className: "years-columns" },
                React.createElement("div", { className: "years-year columns-item" },
                    React.createElement("h5", null, L('Year'))),
                React.createElement("div", { className: "years-options columns-item" },
                    React.createElement("h5", null, L('Options')))),
            React.createElement("div", { className: "list-wrapper" },
                React.createElement("ul", { className: "years-list" }, yearItems)))));
}
export default Years;
